import axios from "axios";
import { get, isEmpty } from "lodash";
import moment from "moment";
import classnames from 'classnames';
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { Card, NavLink, CardBody, CardHeader, Col, Label, Row, Button, Modal, ModalHeader, ModalBody, ModalFooter, Input, Table, Nav, NavItem, TabContent, TabPane, CardTitle, CardText } from "reactstrap";
import Swal from "sweetalert2";
import Style from '../../components/PredictionQuestion'
import { apiBaseUrl } from "../../configs/configs";
import { setAmountState, setEditQuestion, setStatus, stateRefresh, stateValues } from "../../slices/opinionTradingSlice";
const OpinionTrading = (props) => {
    const { match_id, series_id } = props.match.params;
    const [activeTab, setActiveTab] = useState(props.location.tab || '1');

    // For Tabs Function
    const toggleOne = tab => {
        if (activeTab !== tab) setActiveTab(tab);
    }
    const dispatch = useDispatch();
    const opinionTradingSlice = useSelector(state => state.opinionTrading)
    const [imageofQustion, setImageofQuestion] = useState(undefined)
    const [tradingList, setTradingList] = useState([])

    const [modal, setModal] = useState(false);


    useEffect(() => {
        getOpinionTrading()
    }, [])

    // Modal Toggle
    const toggle = () => {
        dispatch(stateRefresh())
        setModal(!modal)
        dispatch(stateValues({ name: 'predic_start_time', value: `${moment().format("YYYY-MM-DD")}T${moment().format("HH:mm")}` }))
        dispatch(stateValues({ name: 'isAdd', value: true }))
    }

    // Add Question Funtion
    const setQuestion = (e) => {
        dispatch(stateValues({ name: e.target.name, value: e.target.value }))
    }

    // Correct Answer of The question
    const selectCorrectAnswer = (e) => {
        const option = opinionTradingSlice.questionStates.option.map(data => data.id === Number(e.target.value) ? { ...data, isCorrect: true } : { ...data, isCorrect: false })
        dispatch(stateValues({ name: 'option', value: option }))
    }

    // Image Upload For Question
    const setQuestionImage = (e) => {
        const file = e.target.files[0]
        setImageofQuestion(file)
    }

    // Get Opinion Trading List
    const getOpinionTrading = async () => {
        const url = `${apiBaseUrl}/trading/${match_id}/${series_id}`
        const response = await axios.get(url)
        if (response.data.status === 'success') {
            setTradingList(response.data.data)
        }
    }

    // Question Verification Button here
    const submit = async () => {
        if (isValidate()) {
            await submitQuestion()
        }
    }

    // Add Question Button here
    const submitQuestion = async () => {
        const formData = new FormData()
        let data = {
            ...opinionTradingSlice.questionStates,
            match_id,
            series_id,
            predic_start_time: moment(opinionTradingSlice.questionStates.predic_start_time).utc().format(),
            predic_end_time: moment(opinionTradingSlice.questionStates.predic_end_time).utc().format(),
        }
        formData.append('image', imageofQustion);
        formData.append('data', JSON.stringify(data));
        const result = await axios.post(`${apiBaseUrl}/trading/${match_id}/${series_id}`, formData)
        if (result.data.status === 'success') {
            if (!opinionTradingSlice.isEdit) {
                Swal.fire({
                    position: 'top-end',
                    icon: 'success',
                    title: 'Question Successfully Added',
                    showConfirmButton: false,
                    timer: 1500
                })
            } else {
                Swal.fire({
                    position: 'top-end',
                    icon: 'success',
                    title: 'Question Successfully Edit',
                    showConfirmButton: false,
                    timer: 1500
                })
            }
        }
        setModal(!modal)
        getOpinionTrading()
    }

    // Alert Function
    const getSweetAlert = (type, topic) => {
        Swal.fire({
            position: 'top-end',
            icon: type,
            title: topic,
            showConfirmButton: false,
            timer: 3000
        })
    }

    // validation for input box
    const isValidate = () => {
        let status = true
        const data = opinionTradingSlice.questionStates
        if (isEmpty(data.question_english)) {
            status = false
            getSweetAlert('error', 'enter the question')
        }
        else if (data.slots_per_user <= 0) {
            status = false
            getSweetAlert('error', 'Enter Slot Per user')
        }
        else if (isEmpty(data.predic_start_time)) {
            status = false
            getSweetAlert('error', 'Start Time Must Be More Than Present Time')

        }
        else if (isEmpty(data.predic_end_time) || (moment(data.predic_end_time).format("YYYY-MM-DD, HH:mm") < moment(data.predic_start_time).format("YYYY-MM-DD, HH:mm"))) {
            status = false
            getSweetAlert('error', 'End Time Must be Larger Than Start Time')
        }
        else if (opinionTradingSlice.isSubjective && data.slots_per_user > 2) {
            status = false
            getSweetAlert('error', 'User Slot Not More Than 2')
        } else if (!opinionTradingSlice.isSubjective && data.slots_per_user > 10000) {
            status = false
            getSweetAlert('error', 'User Slot Not More Than 10000')
        }
        else if (opinionTradingSlice.isSubjective && data.slots > 100) {
            status = false
            getSweetAlert('error', 'Slot Not More Than 100')
        }
        else if (!opinionTradingSlice.isSubjective && data.slots > 100000) {
            status = false
            getSweetAlert('error', 'Slot Not More Than 100000')
        }
        else if (Number(data.slots_per_user) >= Number(data.slots)) {
            console.log(">>>goes here");
            status = false
            getSweetAlert('error', 'User Slot Not More Than Total Slots')
        }
        else if (Number(data.admin_commission) < 10) {
            status = false
            getSweetAlert('error', 'Admin Commission Not Less Than 10')
        } else if (Number(data.rate_id1) && Number(data.rate_id2)) {
            let totalValue = 10
            let totalCorrectAnswer = data.rate_id1 + data.rate_id2 === totalValue
            console.log(totalCorrectAnswer, "")
        }
        return status
    }

    // question edit slice here
    const editQuestion = (data) => {
        setModal(!modal)
        const tradingData = {
            ...data,
            predic_start_time: `${moment(data.predic_start_time).format(
                "YYYY-MM-DD"
            )}T${moment(data.predic_start_time).format("HH:mm")}`,
            predic_end_time: `${moment(data.predic_end_time).format(
                "YYYY-MM-DD"
            )}T${moment(data.predic_end_time).format("HH:mm")}`,
            isEdit: true,
        };
        dispatch(setEditQuestion(tradingData));
        setModal(!modal)
        getOpinionTrading()
    }

    // Change status of question 
    const changeStatus = async (id, status, data) => {
        const result = await axios.post(`${apiBaseUrl}/trading/${match_id}/${series_id}`, { _id: id, status: 1 - status });
            if (result.data.status === "success") {
                Swal.fire({
                    position: "top-end",
                    icon: "success",
                    title: "Status successfully changed",
                    showConfirmButton: false,
                    timer: 1500,
                });
                getOpinionTrading()
            }
    };

    // Cancel trading Function here
    const cancelTrading = async (id) => {
        const res = await Swal.fire({
            title: 'Do you want to cancel the Trading ?',
            showCancelButton: true,
            confirmButtonText: 'Yes',
            cancelButtonText: 'No'
        })
        if (res.isConfirmed) {
            Swal.fire({
                title: 'Wait !',
                text: `While Cancelling  is in the process.`,
                imageUrl: 'https://cdn.dribbble.com/users/164889/screenshots/1192618/loading-red-spot.gif',
                imageWidth: 400,
                imageHeight: 200,
                imageAlt: 'Custom image',
                showConfirmButton: false,
                allowOutsideClick: false
            })
            const result = await axios.post(
                `${apiBaseUrl}/trade/cancel/match/${match_id}/series/${series_id}/trade/${id}`
            );
            if (result.data.status === 'success') {
                // await getQuestions(match_id, series_id, dispatch, addQuestion);
                Swal.close()
                Swal.fire({
                    position: "top-end",
                    icon: "success",
                    title: "Trading Cancel successfully",
                    showConfirmButton: false,
                    timer: 1500,
                });
                getOpinionTrading()
            }
        }else{
            Swal.close()
        }
    };

    // Set winning function here
    const setWinning = async (data) => {
        const res = await Swal.fire({
            title: 'Do you want to Set Winning ?',
            showCancelButton: true,
            confirmButtonText: 'Yes',
            cancelButtonText: 'No'
        })
        if (res.isConfirmed) {
            Swal.fire({
                title: 'Wait !',
                text: `While We are set the winning!`,
                imageUrl: 'https://cdn.dribbble.com/users/164889/screenshots/1192618/loading-red-spot.gif',
                imageWidth: 400,
                imageHeight: 200,
                imageAlt: 'Custom image',
                showConfirmButton: false,
                allowOutsideClick: false
            })
            const trade_id = data._id
            const url = `${apiBaseUrl}/trade/winning_set/match/${match_id}/series/${series_id}/trade/${trade_id}`
            const optionAnser = data.option
            const isCorrectId = (optionAnser.find(data => data.isCorrect)).id
            const bodyData = {
                correct_id: isCorrectId,
                admin_commision: data.admin_commission
            }
            const response = await axios.post(url, bodyData)
            if (response.data.status === 'success') {
                Swal.fire({
                    position: "top-end",
                    icon: "success",
                    title: "Set Winning successfully!",
                    showConfirmButton: false,
                    timer: 1500,
                });
                Swal.close()
                getOpinionTrading()
            }
        }else{
            Swal.close()
        }
    }

    // set Distribute function here
    const setDistribute = async (id) => {
        const res = await Swal.fire({
            title: 'Do you want to Set Distributions ?',
            showCancelButton: true,
            confirmButtonText: 'Yes',
            cancelButtonText: 'No'
        })
      
        if (res.isConfirmed) {
            Swal.fire({
                title: 'Wait !',
                text: `While We are set the winning!`,
                imageUrl: 'https://cdn.dribbble.com/users/164889/screenshots/1192618/loading-red-spot.gif',
                imageWidth: 400,
                imageHeight: 200,
                imageAlt: 'Custom image',
                showConfirmButton: false,
                allowOutsideClick: false
            })
            const result = await axios.post(
                `${apiBaseUrl}/winning_distribute/match/${match_id}/trade/${id}`
            );
            if (result.data.status === 'success') {
                // await getQuestions(match_id, series_id, dispatch, addQuestion);
                Swal.close()
                Swal.fire({
                    position: "top-end",
                    icon: "success",
                    title: "Winning Distribute Successfully",
                    showConfirmButton: false,
                    timer: 1500,
                });
                getOpinionTrading()
            }
        }else{
            Swal.close()
        }

    };

    // Set Force cancel button function here
    const setForceCancel = async (id) => {
        const res = await Swal.fire({
            title: 'Do you want to Force Cancel ?',
            showCancelButton: true,
            confirmButtonText: 'Yes',
            cancelButtonText: 'No'
        })
        if (res.isConfirmed) {
            Swal.fire({
                title: 'Wait !',
                text: `While We are Force cancelling all!`,
                imageUrl: 'https://cdn.dribbble.com/users/164889/screenshots/1192618/loading-red-spot.gif',
                imageWidth: 400,
                imageHeight: 200,
                imageAlt: 'Custom image',
                showConfirmButton: false,
                allowOutsideClick: false
            })
            const result = await axios.post(
                `${apiBaseUrl}/force_cancel/trade/${id}`
            );
            if (result.data.status === 'success') {
                // await getQuestions(match_id, series_id, dispatch, addQuestion);
                Swal.close()
                Swal.fire({
                    position: "top-end",
                    icon: "success",
                    title: "Force Cancel Successfully",
                    showConfirmButton: false,
                    timer: 1500,
                });
                getOpinionTrading()
            }
        }else{
            Swal.close()
        }
    };

    // check answer function here
    const checkAnser = (data) => {
        const optionAnser = data.option
        const trueEv = optionAnser.find(data => data.isCorrect)
        console.log(trueEv,"0000")
        if(trueEv){
            return true
        }
    }

    // for answer valiation 
    const checkAnserForActive = (data) => {
        const optionAnser = data.option
        const trueEv = optionAnser.find(data => data.isCorrect)
        if(trueEv){
            return false
        }else {
            return true
        }
    }


    //tab button for live and finished trading
    
    const liveTrading = (live) => {
        const liveTrade = []
        const finishTrade = []
        for (var trade of tradingList && tradingList) {
            if (trade.is_finish) {
                finishTrade.push(trade)
            } else {
                liveTrade.push(trade)
            }
        }
        if (live === 'live') {
            return liveTrade
        } else {
            return finishTrade
        }
    }
    return (
        <>
            <div className="animated fadeIn">
                <Row>
                    <Col xl={12}>
                        <Card>
                            <CardHeader>
                                <i className="fa fa-align-justify"></i>Opinion Trading<small className="text-muted"></small>
                                <div style={{ float: 'right' }}>
                                    <button className="btn btn-success btn-sm" onClick={toggle}>Add Questions</button>
                                </div>
                            </CardHeader>
                            <CardBody className="tabOne">
                                <Nav tabs fill>
                                    <NavItem style={{ width: "24%", fontSize: "15px" }}>
                                        <NavLink
                                            className={classnames({ active: activeTab === '1' })}
                                            onClick={() => { toggleOne('1'); }}
                                        >
                                            Live Trading
                                        </NavLink>
                                    </NavItem>

                                    <NavItem style={{ width: "24%", fontSize: "15px" }}>
                                        <NavLink
                                            className={classnames({ active: activeTab === '2' })}
                                            onClick={() => { toggleOne('2'); }}
                                        >
                                            Finished Trading
                                        </NavLink>
                                    </NavItem>
                                </Nav>

                                <TabContent activeTab={activeTab}>
                                    <TabPane tabId="1">
                                        <Table>
                                            <thead>
                                                <tr>
                                                    <th>Id</th>
                                                    <th>Question</th>
                                                    <th>Slots Per User</th>
                                                    <th>Rate 1</th>
                                                    <th>Rate 2</th>
                                                    <th>End Time</th>
                                                    <th>Edit</th>
                                                    <th>Status</th>
                                                    <th>Cancel</th>
                                                    <th>Set</th>
                                                    <th>Force Cancel</th>
                                                    <th>Info</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {liveTrading('live').map((data, index) => {
                                                    return <tr>
                                                        <td>{index + 1}</td>
                                                        <td>{data.question_english}</td>
                                                        <td>{data.slots_per_user}</td>
                                                        <td>{data.rate_id1}</td>
                                                        <td>{data.rate_id2}</td>
                                                        <td>{moment(data.predic_end_time).format('YYYY-MM-DD hh:mm:ss')}</td>
                                                        <td>
                                                            <button
                                                                style={{
                                                                    outline: "none",
                                                                    border: "none",
                                                                    boxShadow: "0 0 2px #a9f49e",
                                                                    background: "#FFFF00",
                                                                    padding: "5px 10px",
                                                                    color: "#605858",
                                                                    fontWeight: 700,
                                                                    borderRadius: 5,
                                                                }}
                                                                onClick={() => editQuestion(data)}
                                                            >
                                                                Edit
                                                            </button>
                                                        </td>
                                                        <td> 
                                                            {
                                                            checkAnserForActive(data) ?
                                                            <button
                                                                style={{
                                                                    outline: "none",
                                                                    border: "none",
                                                                    boxShadow: "0 0 2px #f49e9e",
                                                                    background: data.status ? "green" : "rgb(246 60 58 / 68%)",
                                                                    padding: "5px 10px",
                                                                    color: "#fff",
                                                                    fontWeight: 700,
                                                                    borderRadius: 5,
                                                                    border: data.status ? "2px solid green" : "2px solid red"
                                                                }}
                                                                value={data.status === 1 ? 0 : 1}
                                                                onClick={() => changeStatus(data._id, data.status)}
                                                            >
                                                               {data.status === 0 ? 'InActive' : 'Active'}
                                                            </button> : <button
                                                            disabled
                                                                style={{
                                                                    outline: "none",
                                                                    border: "none",
                                                                    boxShadow: "0 0 2px #ccc",
                                                                    background: "#ccc",
                                                                    padding: "5px 10px",
                                                                    color: "#fff",
                                                                    fontWeight: 700,
                                                                    borderRadius: 5,
                                                                    border: "2px solid #ccc"
                                                                }}
                                                                value={data.status === 1 ? 0 : 1}
                                                                onClick={() => changeStatus(data._id, data.status)}
                                                            >
                                                               {data.status === 0 ? 'InActive' : 'Active'}
                                                            </button>
                                                            }
                                                        </td>
                                                        {
                                                            checkAnser(data) && data.status === 0 ?
                                                                <td>
                                                                    {
                                                                        data.is_pred_cancel === 1 ? <button
                                                                            style={{
                                                                                outline: "none",
                                                                                border: "1px solid #ccc",
                                                                                padding: "5px 10px",
                                                                                color: "#ccc",
                                                                                fontWeight: 700,
                                                                                borderRadius: 5,
                                                                            }}
                                                                            disabled
                                                                            onClick={() => cancelTrading(data._id)}
                                                                        >
                                                                            Cancel
                                                                        </button> : <button
                                                                            style={{
                                                                                outline: "none",
                                                                                border: "none",
                                                                                background: "#f63c3a",
                                                                                padding: "5px 10px",
                                                                                color: "#fff",
                                                                                fontWeight: 700,
                                                                                borderRadius: 5,
                                                                            }}
                                                                            onClick={() => cancelTrading(data._id)}
                                                                        >
                                                                            Cancel
                                                                        </button>
                                                                    }

                                                                </td> : <td></td>
                                                        }
                                                        <td>
                                                            {
                                                                data.is_slot_cancel === 1 &&
                                                            <button
                                                                style={{
                                                                    outline: "none",
                                                                    border: "none",
                                                                    background: "green",
                                                                    boxShadow: "0 0 2px #f49e9e",
                                                                    padding: "2px 7px",
                                                                    color: "#fff",
                                                                    fontWeight: 700,
                                                                    borderRadius: 5,
                                                                    marginBottom: '10px'
                                                                }}
                                                                onClick={() => setWinning(data)}
                                                            >
                                                                SET
                                                            </button>
                                                            }
                                                            <br></br>
                                                            {
                                                                data.is_pred_winset === 1 && 
                                                                <button
                                                                style={{
                                                                    outline: "none",
                                                                    border: "none",
                                                                    background: "green",
                                                                    boxShadow: "0 0 2px #f49e9e",
                                                                    padding: "2px 7px",
                                                                    color: "#fff",
                                                                    fontWeight: 700,
                                                                    borderRadius: 5,
                                                                }}
                                                                onClick={() => setDistribute(data._id)}
                                                            >
                                                                Distribute
                                                            </button>
                                                            }
                                                        </td>
                                                        <td>
                                                            {
                                                                 data.status === 0 && 
                                                            <button
                                                                style={{
                                                                    outline: "none",
                                                                    border: "none",
                                                                    background: "#9f0000",
                                                                    boxShadow: "0 0 2px #f49e9e",
                                                                    padding: "2px 7px",
                                                                    color: "#fff",
                                                                    fontWeight: 700,
                                                                    borderRadius: 5,
                                                                }}
                                                                onClick={() => setForceCancel(data._id)}
                                                            >
                                                                Force Cancel
                                                            </button>
                                                            }
                                                        </td>
                                                        <td>
                                                            <Link to={{ pathname: `/opinion-trading-details/${data._id}` }}>
                                                                <button style={{
                                                                    outline: "none",
                                                                    border: "none",
                                                                    background: "#03a9f4",
                                                                    boxShadow: "0 0 2px #f49e9e",
                                                                    padding: "5px 10px",
                                                                    color: "#fff",
                                                                    fontWeight: 700,
                                                                    borderRadius: 5,
                                                                }}>Details</button></Link>
                                                        </td>

                                                    </tr>
                                                })}
                                            </tbody>
                                        </Table>
                                    </TabPane>
                                    <TabPane tabId="2">
                                    <Table>
                                            <thead>
                                                <tr>
                                                    <th>Id</th>
                                                    <th>Question</th>
                                                    <th>Rate 1</th>
                                                    <th>Rate 2</th>
                                                    <th>Answer</th>
                                                    <th>Slots Per User</th>
                                                    <th>End Time</th>
                                                    <th>Edit</th>
                                                    <th>Status</th>
                                                    <th>cancel</th>
                                                    <th>Set</th>
                                                    <th>Force Cancel</th>
                                                    <th>Info</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {liveTrading('finish').map((data, index) => {
                                                    return <tr>
                                                        <td>{index + 1}</td>
                                                        <td>{data.question_english}</td>
                                                        <td>{data.rate_id1}</td>
                                                        <td>{data.rate_id2}</td>
                                                        {/* <td>{(data.option.find(data => data.isCorrect ? data.isCorrect : '').id) === 'undefined' ? 'hello' : 'NO'}</td> */}
                                                        <td>{get(data.option.find(data => data.isCorrect ? data.isCorrect : ''),'id','Blank Answer')}</td>
                                                        <td>{data.slots_per_user}</td>
                                                        <td>{moment(data.predic_end_time).format('YYYY-MM-DD hh:mm:ss')}</td>
                                                        <td>
                                                            <button
                                                               style={{
                                                                outline: "none",
                                                                            border: "1px solid #ccc",
                                                                            padding: "5px 10px",
                                                                            color: "#ccc",
                                                                            fontWeight: 700,
                                                                            borderRadius: 5,
                                                            }}
                                                            disabled
                                                                onClick={() => editQuestion(data)}
                                                            >
                                                                Edit
                                                            </button>
                                                        </td>
                                                        <td>
                                                            <button
                                                                style={{
                                                                    outline: "none",
                                                                                border: "1px solid #ccc",
                                                                                padding: "5px 10px",
                                                                                color: "#ccc",
                                                                                fontWeight: 700,
                                                                                borderRadius: 5,
                                                                }}
                                                                disabled
                                                                value={data.status === 1 ? 0 : 1}
                                                                onClick={() => changeStatus(data._id, data.status)}
                                                            >
                                                                {data.status === 0 ? 'InActive' : 'Active'}
                                                            </button>
                                                        </td>
                                                        {
                                                            checkAnser(data) && data.status === 0 ?
                                                                <td>
                                                                    {
                                                                        data.is_pred_cancel === 1 ? <button
                                                                            style={{
                                                                                outline: "none",
                                                                                border: "1px solid #ccc",
                                                                                padding: "5px 10px",
                                                                                color: "#ccc",

                                                                                fontWeight: 700,
                                                                                borderRadius: 5,
                                                                            }}
                                                                            disabled
                                                                            onClick={() => cancelTrading(data._id)}
                                                                        >
                                                                            Cancel
                                                                        </button> : <button
                                                                           style={{
                                                                            outline: "none",
                                                                                        border: "1px solid #ccc",
                                                                                        padding: "5px 10px",
                                                                                        color: "#ccc",
                                                                                        fontWeight: 700,
                                                                                        borderRadius: 5,
                                                                        }}
                                                                        disabled
                                                                            onClick={() => cancelTrading(data._id)}
                                                                        >
                                                                            Cancel
                                                                        </button>
                                                                    }

                                                                </td> : <td></td>
                                                        }
                                                        <td>
                                                            <button
                                                              style={{
                                                                outline: "none",
                                                                            border: "1px solid #ccc",
                                                                            padding: "5px 10px",
                                                                            color: "#ccc",
                                                                            fontWeight: 700,
                                                                            borderRadius: 5,
                                                            }}
                                                            disabled
                                                                onClick={() => setWinning(data)}
                                                            >
                                                                SET
                                                            </button>
                                                            <br></br>
                                                            <button
                                                                style={{
                                                                    outline: "none",
                                                                    border: "none",
                                                                    background: "green",
                                                                    boxShadow: "0 0 2px #f49e9e",
                                                                    padding: "2px 7px",
                                                                    color: "#fff",
                                                                    fontWeight: 700,
                                                                    borderRadius: 5,
                                                                    marginTop:"10px"
                                                                }}
                                                                onClick={() => setDistribute(data._id)}
                                                            >
                                                                Distribute
                                                            </button>
                                                        </td>
                                                        <td>
                                                            <button
                                                                style={{
                                                                    outline: "none",
                                                                                border: "1px solid #ccc",
                                                                                padding: "5px 10px",
                                                                                color: "#ccc",
                                                                                fontWeight: 700,
                                                                                borderRadius: 5,
                                                                }}
                                                                disabled
                                                                onClick={() => setForceCancel(data._id)}
                                                            >
                                                                Force Cancel
                                                            </button>
                                                        </td>
                                                        <td>
                                                            <Link to={{ pathname: `/opinion-trading-details/${data._id}` }}>
                                                                <button style={{
                                                                    outline: "none",
                                                                    border: "none",
                                                                    background: "#03a9f4",
                                                                    boxShadow: "0 0 2px #f49e9e",
                                                                    padding: "5px 10px",
                                                                    color: "#fff",
                                                                    fontWeight: 700,
                                                                    borderRadius: 5,
                                                                }}>Details</button></Link>
                                                        </td>

                                                    </tr>
                                                })}
                                            </tbody>
                                        </Table>
                                    </TabPane>
                                </TabContent>
                                <Row>

                                </Row>
                                <Row>
                                    <Modal isOpen={modal} toggle={toggle} backdrop="static">
                                        <ModalHeader toggle={toggle}>Add Opinion Trading Questions</ModalHeader>
                                        <ModalBody>
                                            <div style={{ display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap' }}>
                                                <div style={{ width: '30%' }}>
                                                    <p style={{ margin: 0 }}>Slots Per User</p>
                                                    <Input max="10000" placeholder='Slot Per User' type='number' name='slots_per_user' onChange={(e) => e.target.value > 0 && setQuestion(e)} value={opinionTradingSlice.questionStates.slots_per_user} disabled={opinionTradingSlice.isEdit === true ? true : false}></Input>
                                                </div>
                                                <div style={{ width: '40%' }}>
                                                    <p style={{ margin: 0 }}>Admin Commission</p>
                                                    <Input placeholder='Enter Admin Commission' type='number' name='admin_commission' onChange={(e) => e.target.value > 0 && setQuestion(e)} value={opinionTradingSlice.questionStates.admin_commission} disabled={opinionTradingSlice.isEdit === true ? true : false}></Input>
                                                </div>
                                            </div>
                                            <div className={Style.date_time_picker_container}>
                                                <div>
                                                    <p>Start Date and Time</p>
                                                    <Input type='datetime-local' name={'predic_start_time'} onChange={(e) => e.target.value > 0 && setQuestion(e)} value={opinionTradingSlice.questionStates.predic_start_time} disabled={opinionTradingSlice.isEdit === true ? true : false} />
                                                </div>
                                                <div>
                                                    <p>End Date and Time</p>
                                                    <Input type='datetime-local' name={'predic_end_time'} value={opinionTradingSlice.questionStates.predic_end_time} onChange={setQuestion} disabled={opinionTradingSlice.isEdit === true ? false : opinionTradingSlice.isAdd ? false : true} />
                                                </div>
                                                <Input name='question_english' placeholder='write question in english ?' style={{ margin: '10px 5px' }} onChange={setQuestion} value={opinionTradingSlice.questionStates.question_english} disabled={opinionTradingSlice.questionStates.status === 0 ? opinionTradingSlice.isEdit === true ? false : opinionTradingSlice.isAdd ? false : true : true }></Input>
                                                <Input name='question_hindi' placeholder='सवाल हिंदी में लिखें ?' style={{ margin: '10px 5px' }} onChange={setQuestion} value={opinionTradingSlice.questionStates.question_hindi} disabled={opinionTradingSlice.questionStates.status === 0 ? opinionTradingSlice.isEdit === true ? false : opinionTradingSlice.isAdd ? false : true : true }></Input>
                                                {/* <div style={{display:"flex"}}>
                                                    <Input type="number" min="1" max="9" name='rate_id1' placeholder='Yes Amount' style={{ margin: '10px 5px' }} onChange={(e)=>e.target.value > 0 && setAmount(e)} value={opinionTradingSlice.questionStates.rate_id1}></Input>
                                                    <Input type="number" min="1" max="9" name='rate_id2' placeholder='No Amount' style={{ margin: '10px 5px' }} onChange={(e)=>e.target.value > 0 &&  setAmount(e)} value={opinionTradingSlice.questionStates.rate_id2} disabled></Input>
                                                </div>   */}

                                                {!isEmpty(opinionTradingSlice.questionStates.option) &&
                                                    <Input style={{ margin: '10px' }} type='select' value={get(get(opinionTradingSlice, 'questionStates.option', []).find(data => data.isCorrect), 'id', '')} disabled={get(opinionTradingSlice, "questionStates.status") ||  opinionTradingSlice.questionStates.is_slot_cancel === 1 ? true :false } onChange={selectCorrectAnswer}>
                                                        <option value={''}>Select Answer</option>
                                                        {get(opinionTradingSlice, 'questionStates.option', []).map((data, index) =>
                                                            <option value={data.id} key={index}>{data.option}</option>
                                                        )}
                                                    </Input>}
                                                <div>
                                                    <Input type="file" accept='image/*' name='image' onChange={setQuestionImage} />
                                                </div>
                                            </div>
                                        </ModalBody>
                                        <ModalFooter>
                                            <Button color="primary" onClick={submit}>Submit</Button>
                                            <Button color="secondary" onClick={toggle}>Cancel</Button>
                                        </ModalFooter>
                                    </Modal>
                                </Row>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </div>
        </>
    )
}

export default OpinionTrading